var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#006AF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 13.25L9.5 16.25L12.5 13.25L11.375 12.125L10.25 13.25C10.25 12.858 10.3101 12.4801 10.4217 12.125C10.8995 10.6036 12.3209 9.5 14 9.5C14.6498 9.5 15.261 9.66528 15.7939 9.9561L16.8862 8.86382C16.0581 8.31779 15.0661 8 14 8C11.4867 8 9.38582 9.76611 8.87082 12.125C8.79169 12.4874 8.75 12.8638 8.75 13.25L7.625 12.125L6.5 13.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1138 19.1362L12.2061 18.0439C12.7389 18.3347 13.3502 18.5 14 18.5C15.6791 18.5 17.1005 17.3964 17.5783 15.875C17.6899 15.5199 17.75 15.142 17.75 14.75L16.625 15.875L15.5 14.75L18.5 11.75L21.5 14.75L20.375 15.875L19.25 14.75C19.25 15.1362 19.2083 15.5126 19.1292 15.875C18.6142 18.2339 16.5133 20 14 20C12.9338 20 11.9419 19.6822 11.1138 19.1362Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/Reset.5cd83f3f0d055153b4c8907d8969402d.svg";
export { ForwardRef as ReactComponent };